import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getBrand} from "./BrandActions";
import * as utils from "../../utils";

class Brand extends Component {
    componentWillMount() {
        this.props.getBrand();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        document.title = nextProps.brand.name + ' - My Account';
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = utils.getAppProps(nextProps.brand).favIcon;
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    render() {
        return <div/>;
    }
}

const mapStateToProps = ({brand}) => ({brand});

export default connect(mapStateToProps, {getBrand})(Brand);



// WEBPACK FOOTER //
// ./src/components/brand/Brand.js